<template>
  <div>
    <div class="main-container">
      <div
        class="
          asc-page-heading
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <img
            @click="
              roles.includes('GET_JOBDASHBOARD') ? goBackKanban() : goBack()
            "
            src="../../assets/img/feedbackform/backarrow.svg"
            class="pointer"
            alt=""
          />
          <div
            @click="jobCards.length > 1 ? toggleJobCard() : ''"
            class="
              dashboardAdmin-header-main-head
              ml-2
              position-relative
              pointer
            "
            ref="close-job"
            v-closable="{
              exclude: ['close-job', 'select-job'],
              handler: 'closeJobCard',
            }"
          >
            <span>{{ this.$route.query.jobName }}</span>
            <template v-if="jobCards.length > 1">
              <span class="ml-2" v-if="!isJobDropdown"
                ><img
                  src="../../assets/img/newkanban/downsmallarrow.svg"
                  alt=""
              /></span>
              <span v-else class="ml-2"
                ><img src="../../assets/img/newkanban/upsmallarrow.svg" alt=""
              /></span>
            </template>
            <div
              class="kanban-job-dd"
              @scroll="onScrollJob"
              ref="select-job"
              v-if="isJobDropdown"
            >
              <div
                @click="selectJobCard(job)"
                :class="
                  $route.query.jobID == job.jobID
                    ? 'kanban-job-dd-active'
                    : 'kanban-job-dd-inactive'
                "
                v-for="job in jobCards"
                :key="job.jobID"
              >
                {{ job.title }}
              </div>
              <div
                style="margin: auto"
                v-if="showJobSpinner"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="roles.includes('GET_JOBDASHBOARD')"
          class="d-flex rep-switchParent"
        >
          <div
            @click="goBackKanban()"
            class="switchChild"
            :class="
              $route.name == 'Kanban'
                ? 'activeSwitchLeft'
                : 'notActiveSwitchRight'
            "
          >
            <img
              src="../../assets/New-imgs/landing-dashboard/graph2-g.svg"
              alt=""
            />
          </div>
          <div
            class="switchChild"
            :class="
              $route.name == 'Analytics'
                ? 'activeSwitchLeft'
                : 'notActiveSwitchRight'
            "
          >
            <img
              src="../../assets/New-imgs/landing-dashboard/graph1-w.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="rep-overflow mt-12px">
        <div class="rep-white-header">
          <div class="modal-subheads">Overview</div>
          <div class="d-flex align-items-center justify-content-between w-85">
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">No. of Openings</span
              ><span class="rep-blue-txt">{{
                overViewReportData.openings
              }}</span>
            </div>
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">Candidates Added</span
              ><span class="rep-blue-txt">{{
                overViewReportData.candidates
              }}</span>
            </div>
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">Selected</span
              ><span class="rep-blue-txt">{{
                overViewReportData.selected
              }}</span>
            </div>
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">On Hold</span
              ><span class="rep-blue-txt">{{ overViewReportData.onHold }}</span>
            </div>
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">Rejected</span
              ><span class="rep-blue-txt">{{
                overViewReportData.rejected
              }}</span>
            </div>
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">Not Interested</span
              ><span class="rep-blue-txt">{{
                overViewReportData.notInterested
              }}</span>
            </div>
            <div>
              <span class="cp-grey-reg-txt-5 mr-3">In Progress</span
              ><span class="rep-blue-txt">{{
                overViewReportData.inProgress
              }}</span>
            </div>
          </div>
        </div>
        <div class="half-graph-container mt-12px">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              border-bottom
              px-2
              pb-2
            "
          >
            <div class="dashboardAdmin-cards-head ml-2">Job Statistics</div>
            <div class="mr-2">
              <!-- <img
                src="../../assets/New-imgs/landing-dashboard/showGraph.svg"
                alt=""
              /> -->
            </div>
          </div>
          <div
            style="margin: auto"
            v-if="funnelLoader"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <div
            v-else
            class="d-flex align-items-center w-100"
            style="height: 85%"
          >
            <div
              style="width: 95%; height: 100%"
              class="mr-3"
              id="funnel"
            ></div>
            <div
              class="
                funnelgraph-detail-container
                d-flex
                align-items-center
                flex-column
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center flex-column">
                <div>
                  <img src="../../assets/ReportsNew/funnelonhold.svg" alt="" />
                </div>
                <div class="funnel-onhold-numbertxt">
                  {{ jobStatsData.onHoldCount }}
                </div>
                <div class="funnel-onhold-text">On Hold</div>
              </div>
              <hr style="border-top: 1px solid #c4c4c4" class="w-75" />
              <div class="d-flex align-items-center flex-column">
                <div>
                  <img
                    src="../../assets/ReportsNew/funnelrejected.svg"
                    alt=""
                  />
                </div>
                <div class="funnel-onhold-numbertxt">
                  {{ jobStatsData.rejectedCount }}
                </div>
                <div class="funnel-onhold-text">Rejected</div>
              </div>
              <hr style="border-top: 1px solid #c4c4c4" class="w-75" />
              <div class="d-flex align-items-center flex-column">
                <div>
                  <img src="../../assets/ReportsNew/funnelni.svg" alt="" />
                </div>
                <div class="funnel-onhold-numbertxt">
                  {{ jobStatsData.notInterestedCount }}
                </div>
                <div class="funnel-onhold-text">Not interested</div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="w-33 pr-12px">
            <div class="half-graph-container mt-12px">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  border-bottom
                  px-2
                  pb-2
                "
              >
                <div class="dashboardAdmin-cards-head ml-2">
                  Vendor Statistics
                </div>
                <div class="d-flex align-items-center">
                  <span class="rep-grey-txt mr-3"
                    >Total Vendors : {{ totalVendorCount }}</span
                  >
                  <img
                    v-if="totalVendorCount > 0"
                    @click="getExpandGraph('vendor')"
                    v-b-modal.showgraph
                    src="../../assets/New-imgs/landing-dashboard/showGraph.svg"
                    alt=""
                  />
                </div>
              </div>
              <div>
                <div
                  v-if="totalVendorCount > 0"
                  class="
                    h-100
                    d-flex
                    align-items-center
                    justify-content-center
                    mt-2
                    mb-2
                  "
                >
                  <div
                    class="d-flex align-items-center ml-5"
                    v-for="(ven, i) in vendorData"
                    :key="i + 'vens'"
                  >
                    <div
                      class="legend-color-circle mr-1"
                      :style="{ backgroundColor: ven.clrCode }"
                    ></div>
                    <div class="legend-heading">{{ ven.name }}</div>
                  </div>
                </div>

                <!-- totalVendorCount < 1 -->
                <div
                  style="position: relative; top: 105px"
                  v-if="vendorLoader"
                  class="d-flex justify-content-center align-items-center h-100"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
                <div
                  v-else-if="totalVendorCount < 1 && !vendorLoader"
                  style="position: relative; top: 90px"
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    w-100
                    h-100
                  "
                >
                  <img
                    src="../../assets/ReportsNew/thirdPartyNodata.svg"
                    alt=""
                  />
                </div>
                <div v-else id="vendorStatsAll"></div>
              </div>
            </div>
          </div>
          <div class="w-33 pr-12px">
            <div class="half-graph-container mt-12px">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  border-bottom
                  px-2
                  pb-2
                "
              >
                <div class="dashboardAdmin-cards-head ml-2">
                  Recruiter Statistics
                </div>
                <div class="d-flex align-items-center">
                  <span
                    v-if="customerDetail.lead || customerDetail.manager"
                    class="rep-grey-txt mr-3"
                    >Total Recruiters : {{ totalRecruiterCount }}</span
                  >
                  <img
                    v-if="
                      (totalRecruiterCount > 0 && customerDetail.lead) ||
                      customerDetail.manager
                    "
                    @click="getExpandGraph('recruiter')"
                    v-b-modal.showgraph
                    src="../../assets/New-imgs/landing-dashboard/showGraph.svg"
                    alt=""
                  />
                </div>
              </div>

              <div
                style="margin: auto"
                v-if="recLoader"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>

              <div
                v-else-if="totalRecruiterCount < 1 && !recLoader"
                style="position: relative"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  w-100
                  h-100
                "
              >
                <img
                  src="../../assets/ReportsNew/thirdPartyNodata.svg"
                  alt=""
                />
              </div>
              <div v-else class="mt-3" id="recruiterStatsAll"></div>
            </div>
          </div>
          <div class="w33">
            <div class="half-graph-container mt-12px">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  border-bottom
                  px-2
                  pb-2
                "
              >
                <div class="dashboardAdmin-cards-head ml-2">
                  Panelist Statistics
                </div>
                <div class="d-flex align-items-center">
                  <span class="rep-grey-txt mr-3"
                    >Total Panelists : {{ totalPanelistCount }}</span
                  >
                  <img
                    v-if="totalPanelistCount > 0"
                    @click="getExpandGraph('panelist')"
                    v-b-modal.showgraph
                    src="../../assets/New-imgs/landing-dashboard/showGraph.svg"
                    alt=""
                  />
                </div>
              </div>

              <div
                style="margin: auto"
                v-if="panelLoader"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>

              <div
                v-else-if="totalPanelistCount < 1 && !panelLoader"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  w-100
                  h-100
                "
              >
                <img
                  src="../../assets/ReportsNew/thirdPartyNodata.svg"
                  alt=""
                />
              </div>
              <div
                v-else
                class="mt-3 overflow-auto"
                id="panelistSelectAll"
              ></div>
            </div>
          </div>
        </div>
        <div class="d-flex" v-if="overViewReportData.showAssessmentGraph">
          <div class="w-33 pr-12px">
            <div class="half-graph-container mt-12px">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  border-bottom
                  px-2
                  pb-2
                "
              >
                <div class="dashboardAdmin-cards-head ml-2">
                  Assessments Statistics
                </div>
                <div v-if="!noAssessmentData" class="d-flex align-items-center">
                  <img
                    @click="callAssessmentGraph()"
                    v-b-modal.showgraph
                    src="../../assets/New-imgs/landing-dashboard/showGraph.svg"
                    alt=""
                  />
                </div>
              </div>
              <div
                v-if="!noAssessmentData && !assessLoader"
                class="
                  d-flex
                  align-items-center
                  justify-content-around
                  mt-2
                  mb-2
                "
              >
                <div
                  class="d-flex align-items-center"
                  v-for="(asses, i) in assessmentLegend"
                  :key="i + 'asses'"
                >
                  <div
                    class="legend-color-circle mr-1"
                    :style="{ backgroundColor: asses.clrCode }"
                  ></div>
                  <div class="legend-heading">{{ asses.name }}</div>
                </div>
              </div>

              <div
                style="margin: auto"
                v-if="assessLoader"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <div
                v-else-if="noAssessmentData && !assessLoader"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  w-100
                  h-100
                "
              >
                <img
                  src="../../assets/ReportsNew/thirdPartyNodata.svg"
                  alt=""
                />
              </div>
              <div v-else id="assessGraph"></div>
            </div>
          </div>
          <div class="w-33 pr-12px"></div>
          <div class="w33"></div>
        </div>
      </div>
    </div>
    <b-modal
      id="showgraph"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      @hidden="hideModalShowGraph"
    >
      <div>
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            border-bottom
            p-3
          "
        >
          <div class="dashboardAdmin-cards-head ml-2">
            {{ modalHeadingVal }}
          </div>
          <div class="d-flex align-items-center">
            <div
              class="d-flex align-items-center mr-3"
              v-for="(ven, i) in commonColourData"
              :key="i + 'vens'"
            >
              <div
                class="legend-color-circle mr-1"
                :style="{ backgroundColor: ven.clrCode }"
              ></div>
              <div class="legend-heading">{{ ven.name }}</div>
            </div>
            <span class="rep-grey-txt mr-3"
              >Total Count : {{ totalExpandCount }}</span
            >
            <img
              @click="hideModalShowGraph"
              class="rotate-on-hover mr-2"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <div class="newreport-modal-height">
          <div style="overflow-x: auto" id="expandGraphChart">
            <template v-if="showExpandLoader">
              <div
                style="
                  top: 0;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  position: absolute;
                  margin: auto;
                "
                class="d-flex justify-content-center align-items-center"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  overViewAnalytics,
  vendorStatReport,
  recriterStatReport,
  panelistStatReport,
  asessmentStatReport,
  vendorStatReportAll,
  recriterStatReportAll,
  panelistStatReportAll,
  funnelApi,
  getSingleJob,
} from "../../utils/apiFunctions";
import {
  vendorStat,
  recruiterStat,
  assesGraphStat,
  allExpandClass,
  funnelChart,
} from "vue-d3-charts-hire3x";

export default {
  name: "Analytics",
  data() {
    return {
      showJobSpinner: true,
      showExpandLoader: true,
      totalVendorCount: null,
      totalRecruiterCount: null,
      totalPanelistCount: null,
      fixedExpandData: null,
      n: 2,
      modalHeadingVal: "",
      noRecruiterExpand: true,
      vendorData: [],
      totalExpandCount: null,
      noAssessmentData: true,
      overallAssessmentData: [],
      assessmentLegend: [],
      commonColourData: [],

      //Overview Data
      overViewReportData: {},
      funnelLoader: true,
      vendorLoader: true,
      recLoader: true,
      panelLoader: true,
      assessLoader: true,
      jobStatsData: {},
      jobCards: [],
      jobPage: 0,
      jobPageEnd: null,
      jobTotal: null,
      isJobDropdown: false,
    };
  },
  created() {
    this.getAllData();
    //Later remove the function
    // this.getExpandGraph("vendor");
  },
  computed: {
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    ...mapGetters({ roles: "roles" }),
  },
  methods: {
    getAllData() {
      this.getJobs();
      this.getOverviewData();
      this.getVendorStatGraph();
      this.getRecruiterStatGraph();
      this.getPanelistStatGraph();
      this.getAssessmentStatGraph();
      this.makeFunnelGraph();
    },
    onScrollJob(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.jobPageEnd, 0, this.jobTotal) &&
          !this.showJobSpinner
        ) {
          this.showJobSpinner = true;
          this.jobPage++;
          this.getJobs();
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    async waitForElement(selector, timeout = 2000, interval = 50) {
      const start = Date.now();
      while (Date.now() - start < timeout) {
        const el = document.querySelector(selector);
        if (el) return el;
        await new Promise((r) => setTimeout(r, interval));
      }
      return null;
    },
    selectJobCard(job) {
      this.$router.push({
        name: "Analytics",
        query: {
          jobID: job.jobID,
          customerID: job.customerID,
          cardName: this.$route.query.cardName,
          jobName: job.title,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
        },
      });
      this.getAllData();
    },
    closeJobCard() {
      this.isJobDropdown = false;
    },
    async toggleJobCard() {
      if (this.isJobDropdown) {
        this.isJobDropdown = !this.isJobDropdown;
      } else {
        this.jobPage = 0;
        this.showJobSpinner = false;
        await this.getJobs();
        this.isJobDropdown = true;
      }
    },
    async getJobs() {
      let payload = {
        type: "1",
        customerID: this.$route.query.customerID,
        sortBy: "updatedAt",
        order: "-1",
        searchQuery: "",
        page: this.jobPage,
        count: 10,
        status: "3",
        lead: this.customerDetail.lead || this.customerDetail.manager,
        manager: this.customerDetail.manager,
      };
      const res = await getSingleJob(payload);
      if (res.status == 200) {
        if (this.jobPage == 0) {
          this.jobCards = res.data.data.data;
        } else {
          this.jobCards = [...this.jobCards, ...res.data.data.data];
        }
        this.jobTotal = res.data.data.total;
        this.jobPageEnd = res.data.data.pageEnd;
        this.showJobSpinner = false;
      }
    },
    goBack() {
      this.$router.push({
        name: `InternalHiringDashboard`,
        query: {
          cardName: this.$route.query.cardName,
          gridView: this.$route.query.gridView,
        },
        params: {
          cardName: this.$route.query.cardName,
          customerID: this.$route.query.customerID,
        },
      });
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },
    async getOverviewData() {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        const resp = await overViewAnalytics(payload);
        if (resp.status == 200) {
          this.overViewReportData = resp.data.data;
        } else {
          console.error("Api Error");
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getVendorStatGraph() {
      if (
        document.getElementById("vendorStatsAll") &&
        document.getElementById("vendorStatsAll").innerHTML != ""
      ) {
        document.getElementById("vendorStatsAll").innerHTML = "";
      }
      this.vendorLoader = true;
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        const resp = await vendorStatReport(payload);
        if (resp.status == 200) {
          this.totalVendorCount = resp.data.data.vendorCount;
          const passData = [
            {
              selectedVendorCandidates: resp.data.data.selectedVendorCandidates,
              vendorCandidates: resp.data.data.vendorCandidates,
              // selectedVendorCandidates: 1,
              // vendorCandidates: 100
            },
          ];
          this.vendorData = [
            {
              name: "Total Vendors Candidate",
              count: resp.data.data.vendorCandidates,
              clrCode: "#F5D06E",
            },
            {
              name: "Selected Candidates",
              count: resp.data.data.selectedVendorCandidates,
              clrCode: "#269C8A",
            },
          ];

          this.commonColourData = [
            {
              name: "Total Vendors Candidate",
              clrCode: "#F5D06E",
            },
            {
              name: "Selected Candidates",
              clrCode: "#269C8A",
            },
          ];
          setTimeout(() => {
            if (
              document.getElementById("vendorStatsAll") &&
              document.getElementById("vendorStatsAll").innerHTML != ""
            ) {
              document.getElementById("vendorStatsAll").innerHTML = "";
            }
            const vendorDataChart = new vendorStat();
            vendorDataChart.statGraph(passData);
          }, 200);
        } else {
          console.error("Api Error");
        }
      } catch (error) {
        console.error(error);
      }
      this.vendorLoader = false;
    },
    async getRecruiterStatGraph() {
      if (
        document.getElementById("recruiterStatsAll") &&
        document.getElementById("recruiterStatsAll").innerHTML != ""
      ) {
        document.getElementById("recruiterStatsAll").innerHTML = "";
      }
      this.recLoader = true;
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        const resp = await recriterStatReport(payload);
        if (resp.status == 200) {
          const PassData = resp.data.data.data;
          this.totalRecruiterCount = resp.data.data.recruiterCount;
          const clrScale = ["#F5D06E", "#595959", "#269C8A"];
          setTimeout(() => {
            if (
              document.getElementById("recruiterStatsAll") &&
              document.getElementById("recruiterStatsAll").innerHTML != ""
            ) {
              document.getElementById("recruiterStatsAll").innerHTML = "";
            }
            const vendorDataChart = new recruiterStat();
            vendorDataChart.horizontalBarGraph(
              "#recruiterStatsAll",
              clrScale,
              PassData
            );
          }, 200);
        } else {
          console.error("Api Error");
        }
      } catch (error) {
        console.error(error);
      }
      this.recLoader = false;
    },
    async getPanelistStatGraph() {
      if (
        document.getElementById("panelistSelectAll") &&
        document.getElementById("panelistSelectAll").innerHTML != ""
      ) {
        document.getElementById("panelistSelectAll").innerHTML = "";
      }
      this.panelLoader = true;
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        const resp = await panelistStatReport(payload);
        if (resp.status == 200) {
          const passData = resp.data.data.data;
          this.totalPanelistCount = resp.data.data.panelCount;
          const clrScale = ["#F5D06E", "#269C8A", "#AD1927"];

          setTimeout(() => {
            if (
              document.getElementById("panelistSelectAll") &&
              document.getElementById("panelistSelectAll").innerHTML != ""
            ) {
              document.getElementById("panelistSelectAll").innerHTML = "";
            }
            const vendorDataChart = new recruiterStat();
            vendorDataChart.horizontalBarGraph(
              "#panelistSelectAll",
              clrScale,
              passData
            );
          }, 200);
        } else {
          console.error("Api Error");
        }
      } catch (error) {
        console.error(error);
      }
      this.panelLoader = false;
    },
    async getAssessmentStatGraph() {
      if (
        document.getElementById("assessGraph") &&
        document.getElementById("assessGraph").innerHTML != ""
      ) {
        document.getElementById("assessGraph").innerHTML = "";
      }
      this.assessLoader = true;
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        const resp = await asessmentStatReport(payload);
        if (resp.status == 200) {
          const passData = resp.data.data;
          this.totalExpandCount = passData.length;
          this.fixedExpandData = this.totalExpandCount;
          if (passData.length > 0) {
            this.assessmentLegend = [
              {
                name: "Assessment Triggered",
                clrCode: "#F5D06E",
              },
              {
                name: "Selected",
                clrCode: "#269C8A",
              },
              {
                name: "Rejected",
                clrCode: "#AD1927",
              },
            ];

            this.overallAssessmentData = passData
              .map((data) => {
                return Object.keys(data)
                  .map((key) => {
                    return {
                      name: data[key].roundName,
                      candidatesAdded: data[key].assessmentTriggered,
                      scheduledInterview: data[key].selected,
                      selectedCand: data[key].rejected,
                    };
                  })
                  .filter((item) => item !== null);
              })
              .flat(); // Flatten the array of arrays
            this.noAssessmentData = this.areAllCountsZero(
              this.overallAssessmentData,
              "candidatesAdded"
            );
            this.assessLoader = false;
          }
          //     setTimeout(() => {
          //       if (
          //   document.getElementById("assessGraph") &&
          //   document.getElementById("assessGraph").innerHTML != ""
          // ) {
          //   document.getElementById("assessGraph").innerHTML = "";
          // }
          //       const vendorDataChart = new assesGraphStat();
          //       this.totalExpandCount > 2
          //         ? vendorDataChart.horizontalBarGraph(passData.slice(0, 3))
          //         : vendorDataChart.horizontalBarGraph(passData);
          //     }, 1000);

          this.$nextTick(async () => {
            const assessEl = await this.waitForElement("#assessGraph");

            if (!assessEl) {
              console.warn("assessGraph not rendered within timeout");
              return;
            }
            if (assessEl.innerHTML !== "") assessEl.innerHTML = "";

            const vendorDataChart = new assesGraphStat();
            const paramData =
              this.totalExpandCount > 2 ? passData.slice(0, 3) : passData;
            const processedData = paramData.map((item) => {
              const newItem = { ...item }; // clone top-level object
              // iterate numeric keys in the object
              Object.keys(newItem).forEach((key) => {
                if (!isNaN(Number(key)) && newItem[key].roundName) {
                  // truncate roundName if longer than 12
                  newItem[key] = {
                    ...newItem[key],
                    roundName:
                      newItem[key].roundName.length > 12
                        ? newItem[key].roundName.slice(0, 11) + "..."
                        : newItem[key].roundName,
                  };
                }
              });

              return newItem;
            });
            vendorDataChart.horizontalBarGraph(processedData);
          });
        } else {
          console.error("Api Error");
        }
      } catch (error) {
        console.error(error);
      }
      this.assessLoader = false;
    },

    callAssessmentGraph() {
      this.totalExpandCount = this.fixedExpandData;
      this.commonColourData = [
        {
          name: "Assessment Triggered",
          clrCode: "#F5D06E",
        },
        {
          name: "Selected",
          clrCode: "#269C8A",
        },
        {
          name: "Rejected",
          clrCode: "#AD1927",
        },
      ];
      this.modalHeadingVal = "Assessment Statistics";

      setTimeout(() => {
        if (
          document.getElementById("expandGraphChart") &&
          document.getElementById("expandGraphChart").innerHTML != ""
        ) {
          document.getElementById("expandGraphChart").innerHTML = "";
        }
        const expandChart2 = new allExpandClass();
        const clrScale = ["#F5D06E", "#269C8A", "#AD1927"];
        expandChart2.recruiterExpand(
          this.overallAssessmentData,
          clrScale,
          "AseessExpand"
        );
      }, 200);
    },
    async getExpandGraph(graphtoShow) {
      this.showExpandLoader = true;

      try {
        let payload = {
          // jobID: "L041223A001CU006JD094",
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        if (graphtoShow == "vendor") {
          this.commonColourData = [
            {
              name: "Total Vendors Candidate",
              clrCode: "#F5D06E",
            },
            {
              name: "Selected Candidates",
              clrCode: "#269C8A",
            },
          ];

          this.modalHeadingVal = "Vendor Statistics";
          const resp = await vendorStatReportAll(payload);
          if (resp.status == 200) {
            const fixedResp = resp.data.data.data;
            let name = this.projectUsers;
            const myData = Object.keys(fixedResp)
              .map((key) => {
                if (name[key]) {
                  return {
                    name: name[key].username,
                    selectedVendorCandidates:
                      fixedResp[key].selectedVendorCandidates,
                    vendorCandidates: fixedResp[key].vendorCandidates,
                  };
                }
              })
              .filter((item) => item !== null);
            this.totalExpandCount = myData.length;
            setTimeout(() => {
              if (document.getElementById("expandGraphChart").innerHTML != "") {
                document.getElementById("expandGraphChart").innerHTML = "";
              }
              const expandChart = new allExpandClass();
              expandChart.vendorExpand(myData);
            }, 200);
          } else {
            console.error("Api Error");
          }
        } else if (graphtoShow == "recruiter") {
          this.commonColourData = [
            {
              name: "Candidates Added",
              clrCode: "#595959",
            },
            {
              name: "Scheduled Interview",
              clrCode: "#FFC107",
            },
            {
              name: "Selected Candidates",
              clrCode: "#269C8A",
            },
          ];
          this.modalHeadingVal = "Recruiter Statistics";
          const resp = await recriterStatReportAll(payload);
          if (resp.status == 200) {
            const fixedResp = resp.data.data;
            let name = this.projectUsers;
            const myData = Object.keys(fixedResp)
              .map((key) => {
                if (name[key]) {
                  return {
                    name: name[key].username,
                    candidatesAdded: fixedResp[key].recruiterCandidates,
                    scheduledInterview: fixedResp[key].recruiterInterviews,
                    selectedCand: fixedResp[key].selectedRecruiterCandidates,
                  };
                }
              })
              .filter((item) => item !== null);
            this.totalExpandCount = myData.length;
            setTimeout(() => {
              if (document.getElementById("expandGraphChart").innerHTML != "") {
                document.getElementById("expandGraphChart").innerHTML = "";
              }
              const clrScale = ["#595959", "#F5D06E", "#269C8A"];
              const expandChart2 = new allExpandClass();
              expandChart2.recruiterExpand(myData, clrScale, "recruiterExpand");
            }, 200);
          } else {
            console.error("Api Error");
          }
        } else if (graphtoShow == "panelist") {
          this.commonColourData = [
            {
              name: "Interview Taken",
              clrCode: "#F5D06E",
            },
            {
              name: "Selected",
              clrCode: "#269C8A",
            },
            {
              name: "Rejected",
              clrCode: "#AD1927",
            },
          ];
          this.modalHeadingVal = "Panelist Statistics";
          const resp = await panelistStatReportAll(payload);
          if (resp.status == 200) {
            const fixedResp = resp.data.data;

            let name = this.projectUsers;
            const myData = Object.keys(fixedResp)
              .map((key) => {
                if (name[key]) {
                  return {
                    name: name[key].username,
                    candidatesAdded: fixedResp[key].panelInterviews,
                    scheduledInterview: fixedResp[key].panelSelected,
                    selectedCand: fixedResp[key].panelRejected,
                  };
                }
              })
              .filter((item) => item !== null);
            this.totalExpandCount = myData.length;
            const clrScale = ["#F5D06E", "#269C8A", "#AD1927"];
            setTimeout(() => {
              if (document.getElementById("expandGraphChart").innerHTML != "") {
                document.getElementById("expandGraphChart").innerHTML = "";
              }
              const expandChart2 = new allExpandClass();
              expandChart2.recruiterExpand(myData, clrScale, "panelExpand");
            }, 200);
          } else {
            console.error("Api Error");
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.showExpandLoader = false;
    },
    async makeFunnelGraph() {
      if (
        document.getElementById("funnel") &&
        document.getElementById("funnel").innerHTML != ""
      ) {
        document.getElementById("funnel").innerHTML = "";
      }
      this.funnelLoader = true;
      try {
        const payload = {
          jobID: this.$route.query.jobID,
          lead: this.customerDetail.lead || this.customerDetail.manager,
        };
        const response = await funnelApi(payload);
        if (response.status == 200) {
          this.jobStatsData = response.data.data;
          let originalData = response.data.data.data;
          const widthPass = 0;

          setTimeout(() => {
            if (document.getElementById("funnel").innerHTML != "") {
              document.getElementById("funnel").innerHTML = "";
            }
            let img1 = require("@/assets/new-kanban-icons/added.svg");
            let img2 = require("@/assets/new-kanban-icons/Group.svg");
            let img3 = require("@/assets/new-kanban-icons/Vector.svg");
            let images = [img1, img2, img3];
            let e = new funnelChart();
            e.createFunnel(originalData, images, widthPass);
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.funnelLoader = false;
    },

    hideModalShowGraph() {
      this.$bvModal.hide("showgraph");
    },

    goBackKanban() {
      this.$router.push({
        name: "Kanban",
        query: {
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          cardName: this.$route.query.cardName,
          isort: this.$route.query.isort,
          itype: this.$route.query.itype,
        },
      });
    },
  },
};
</script>

<style>
#vendorStatsAll {
  width: 100%;
  height: 200px;
}
</style>
